import React from 'react';
import vegan from '../images/vegan.png';
import gf from '../images/gf.png';
import clinical from '../images/clinical.png';
import gmo from '../images/gmo.png';
import { Grid } from 'semantic-ui-react'

const Footer = () => {
  return (
    <div id="footer-wrapper">
      <Grid columns={3} textAlign="center" divided stackable>
        <Grid.Row>
          <Grid.Column style={{ paddingTop: 14 }}>
            <a href="tel:801-819-9812">801-819-9812</a>
          </Grid.Column>

          <Grid.Column>
            <span>
              Alexandra Murphy<br/>
              <div style={{ marginTop: 7, fontSize: 16 }}>
                US Distribution Office ABAC Products
              </div>
            </span>
          </Grid.Column>

          <Grid.Column style={{ paddingTop: 14 }}>
            <a href="mailto:amurphybioswiss@gmail.com">amurphybioswiss@gmail.com</a>
          </Grid.Column>
        </Grid.Row>
      </Grid>

      <Grid columns={4} divided stackable>
        <Grid.Row>
          <Grid.Column>
            <img src={vegan} width="18" alt="" /> &nbsp;
            <span>Vegan</span>
          </Grid.Column>

          <Grid.Column>
            <img src={gf} width="18" alt="" /> &nbsp;
            <span>Gluten-Free</span>
          </Grid.Column>

          <Grid.Column>
            <img src={clinical} width="18" alt="" /> &nbsp;
            <span>Clinically Tested</span>
          </Grid.Column>

          <Grid.Column>
            <img src={gmo} width="22" alt="" /> &nbsp;
            <span>Non-GMO</span>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </div>
  );
}

export default Footer;


// WEBPACK FOOTER //
// ./src/components/Footer.js